import type { SearchConfig } from '@eliadmin/core/src/components/header/search-bar/search-config-types';

export const SEARCH_CONFIG: SearchConfig = {
  mode: 'drawer',
  field: {
    nativeButton: true,
    buttonClassName:
      'inline-flex items-center justify-center h-10 w-10 rounded-lg border-none p-0 bg-primary text-primary-foreground',
    className: { input: { main: 'pointer-events-auto' } },
  },
  sections: ['products', 'categories', 'manufacturers'],
};
